import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"
import JobDetailsContainer from "@legacy/jobs/JobDetailsContainer"

import useHasAccess from "@hooks/useHasAccess"
import useIsDesktop from "@hooks/useIsDesktop"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { useJobsBackDestination } from "@pages/Jobs/Jobs.store"

import { JOBS_ROUTES } from "@routes/jobs"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function JobDetails() {
    const isDesktop = useIsDesktop()

    const [listRoute] = useSlugExtractor([JOBS_ROUTES.LIST])

    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const cleanedJobsListRoute = useJobsBackDestination(listRoute)

    const backDestination = hasPermission("jobs_list_permission", PERMISSION_LEVEL.FULL)
        ? cleanedJobsListRoute
        : undefined

    return (
        <AppFrame.Root pageId="JobDetails">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageTitle
                            label="Jobs"
                            icon={icon({ name: "wrench-simple", style: "regular", family: "sharp" })}
                            iconActive={icon({ name: "wrench-simple", style: "solid", family: "sharp" })}
                            destination={backDestination}
                            iconOnly={!isDesktop}
                        />
                        <TopBar.VerticalDivider />
                        <TopBar.PageSubtitle label="Job Details" backDestination={backDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <JobDetailsContainer addToastToQueue={addToastToQueue} backDestination={backDestination} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
